import { Component } from '@angular/core';
import { ProviderNotifiedAssessment } from 'src/app/calvin-emr-shared/models/assessments/provider-notified.model';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { BooleanToYesNoPipe } from 'src/app/shared/utils/boolean-to-yes-no.pipe';

@Component({
  selector: 'app-provider-notified-info',
  standalone: true,
  templateUrl: './provider-notified-info.component.html',
  styleUrl: './provider-notified-info.component.scss',
  imports: [
    AssessmentRowComponent,
    BooleanToYesNoPipe,
  ],
})
export class ProviderNotifiedInfoComponent extends AssessmentInfoComponent<ProviderNotifiedAssessment> {
  constructor() {
    super();
  }

}
